import {Component} from '@angular/core';
import {MarketService} from "../../services/market/market.service";

@Component({
  selector: 'app-steam-inventory',
  templateUrl: './steam-inventory.component.html',
  styleUrls: ['./steam-inventory.component.scss']
})
export class SteamInventoryComponent {

  public steamItems$ = this.marketService.steamItems$;

  constructor(private marketService: MarketService) {
    this.marketService.requestSteamItems();
  }
}
